import { render, staticRenderFns } from "./DropdownOption.vue?vue&type=template&id=a9a2b36a&"
import script from "./DropdownOption.vue?vue&type=script&lang=ts&"
export * from "./DropdownOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports